// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 海螺图片生成节点样式 */

.MinimaxImageNode-container {
  position: relative;
  background: white;
  border: 2px solid #ddd;
  border-radius: 12px;
  padding: 16px;
  min-width: 320px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
}

.MinimaxImageNode-container:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.MinimaxImageNode-title {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-family: monospace;
}

.MinimaxImageNode-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 字段 */
.MinimaxImageNode-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.MinimaxImageNode-label {
  font-size: 12px;
  font-weight: 600;
  color: #333;
}

/* 按钮组 */
.MinimaxImageNode-button-group {
  display: flex;
  gap: 8px;
}

.MinimaxImageNode-button {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  color: #333;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.MinimaxImageNode-button:hover:not(:disabled) {
  border-color: #3b82f6;
  color: #3b82f6;
}

.MinimaxImageNode-button-active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: #667eea;
}

.MinimaxImageNode-button:disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}

/* 下拉选择 */
.MinimaxImageNode-select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  background-color: white;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.MinimaxImageNode-select:focus {
  outline: none;
  border-color: #3b82f6;
}

.MinimaxImageNode-select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

/* 滑块 */
.MinimaxImageNode-slider-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.MinimaxImageNode-slider {
  flex: 1;
  height: 6px;
  border-radius: 3px;
  background: #e5e7eb;
  outline: none;
  -webkit-appearance: none;
}

.MinimaxImageNode-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  cursor: pointer;
  transition: transform 0.2s ease;
}

.MinimaxImageNode-slider::-webkit-slider-thumb:hover {
  transform: scale(1.2);
}

.MinimaxImageNode-slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  cursor: pointer;
  border: none;
  transition: transform 0.2s ease;
}

.MinimaxImageNode-slider::-moz-range-thumb:hover {
  transform: scale(1.2);
}

.MinimaxImageNode-slider:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.MinimaxImageNode-slider-value {
  font-size: 12px;
  font-weight: 600;
  color: #667eea;
  min-width: 50px;
  text-align: right;
}

/* 输入框 */
.MinimaxImageNode-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  transition: border-color 0.2s ease;
}

.MinimaxImageNode-input:focus {
  outline: none;
  border-color: #3b82f6;
}

.MinimaxImageNode-input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

/* 复选框 */
.MinimaxImageNode-checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  user-select: none;
}

.MinimaxImageNode-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.MinimaxImageNode-checkbox:disabled {
  cursor: not-allowed;
}

/* 画风设置区域 */
.MinimaxImageNode-style-section {
  padding: 12px;
  background-color: #f9fafb;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 高级设置 */
.MinimaxImageNode-advanced {
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
}

.MinimaxImageNode-advanced-toggle {
  width: 100%;
  padding: 8px 12px;
  background: transparent;
  border: none;
  color: #667eea;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
  transition: color 0.2s ease;
}

.MinimaxImageNode-advanced-toggle:hover:not(:disabled) {
  color: #764ba2;
}

.MinimaxImageNode-advanced-toggle:disabled {
  color: #999;
  cursor: not-allowed;
}

.MinimaxImageNode-advanced-content {
  margin-top: 12px;
  padding: 12px;
  background-color: #f9fafb;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 提示信息 */
.MinimaxImageNode-hint {
  font-size: 11px;
  color: #999;
  line-height: 1.4;
  padding: 8px;
  background-color: #f9fafb;
  border-radius: 6px;
}

/* 生成按钮 */
.MinimaxImageNode-generate {
  width: 100%;
  padding: 12px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.MinimaxImageNode-generate:hover:not(.MinimaxImageNode-generate-disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.MinimaxImageNode-generate:active:not(.MinimaxImageNode-generate-disabled) {
  transform: translateY(0);
}

.MinimaxImageNode-generate-disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* 错误提示 */
.MinimaxImageNode-error {
  padding: 10px 12px;
  background-color: #fee;
  color: #c33;
  border-radius: 6px;
  font-size: 12px;
  border-left: 3px solid #c33;
}

/* Handle 样式 */
.MinimaxImageNode-handle {
  width: 14px;
  height: 14px;
  border: 2px solid #667eea;
  background: white;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.MinimaxImageNode-handle:hover {
  width: 18px;
  height: 18px;
  border-width: 3px;
}

/* 不同类型的 Handle 颜色区分 */
.MinimaxImageNode-handle-prompt {
  border-color: #667eea;
  background: #667eea;
}

.MinimaxImageNode-handle-image {
  border-color: #48bb78;
  background: #48bb78;
}

.MinimaxImageNode-handle-output {
  border-color: #8b5cf6;
  background: #8b5cf6;
}

/* Handle 标签 */
.MinimaxImageNode-handle-label {
  position: absolute;
  left: -70px;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.025em;
  z-index: 100;
}

/* 可点击的 Handle 标签 */
.MinimaxImageNode-handle-label-clickable {
  pointer-events: auto;  /* 改为可交互 */
  cursor: pointer;       /* 显示手型光标 */
  user-select: none;     /* 禁止文本选择 */
}

/* 可点击标签的悬停效果 */
.MinimaxImageNode-handle-label-clickable:hover {
  transform: translateY(-50%) translateX(-4px) scale(1.05);
  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.45);
  background: linear-gradient(135deg, #a78bfa 0%, #9333ea 100%);
}

/* 可点击标签的按下效果 */
.MinimaxImageNode-handle-label-clickable:active {
  transform: translateY(-50%) translateX(-2px) scale(0.98);
}

/* 添加点击提示图标 */
.MinimaxImageNode-handle-label-clickable::after {
  content: ' +';
  font-weight: 700;
  margin-left: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.MinimaxImageNode-handle-label-clickable:hover::after {
  opacity: 1;
}

/* 悬停时显示标签 */
.MinimaxImageNode-handle:hover .MinimaxImageNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.35);
}

.MinimaxImageNode-handle:hover .MinimaxImageNode-handle-label::before {
  content: '';
  position: absolute;
  right: -4px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid #8b5cf6;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  filter: drop-shadow(0 1px 2px rgba(139, 92, 246, 0.2));
}

.MinimaxImageNode-handle-prompt .MinimaxImageNode-handle-label {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
}

.MinimaxImageNode-handle-prompt:hover .MinimaxImageNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.MinimaxImageNode-handle-prompt:hover .MinimaxImageNode-handle-label::before {
  border-left-color: #667eea;
  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));
}

.MinimaxImageNode-handle-image .MinimaxImageNode-handle-label {
  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);
  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);
}

.MinimaxImageNode-handle-image:hover .MinimaxImageNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

.MinimaxImageNode-handle-image:hover .MinimaxImageNode-handle-label::before {
  border-left-color: #48bb78;
  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));
}

/* 节点被选中时，一直显示标签 */
.react-flow__node.selected .MinimaxImageNode-handle .MinimaxImageNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.35);
}

.react-flow__node.selected .MinimaxImageNode-handle-prompt .MinimaxImageNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.react-flow__node.selected .MinimaxImageNode-handle-image .MinimaxImageNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

/* 标签出现动画 */
@keyframes MinimaxImageNode-labelFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-50%) translateX(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) translateX(-2px);
  }
}

.MinimaxImageNode-handle:hover .MinimaxImageNode-handle-label,
.react-flow__node.selected .MinimaxImageNode-handle .MinimaxImageNode-handle-label {
  animation: MinimaxImageNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 连接状态显示 */
.MinimaxImageNode-status {
  margin-bottom: 12px;
  padding: 12px;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.MinimaxImageNode-status-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
}

.MinimaxImageNode-status-item:not(:last-child) {
  border-bottom: 1px dashed #e5e7eb;
  margin-bottom: 6px;
  padding-bottom: 8px;
}

.MinimaxImageNode-status-label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
}

.MinimaxImageNode-status-value {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.MinimaxImageNode-status-connected {
  color: #10b981;
  background: #d1fae5;
  border: 1px solid #10b981;
}

.MinimaxImageNode-status-disconnected {
  color: #ef4444;
  background: #fee2e2;
  border: 1px solid #ef4444;
}

/* 复制按钮 */
.MinimaxImageNode-duplicate-button {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s ease;
  opacity: 0;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.MinimaxImageNode-container:hover .MinimaxImageNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

.MinimaxImageNode-duplicate-button:hover {
  background: #f0f0f0;
  border-color: #3b82f6;
  color: #3b82f6;
  transform: scale(1.05);
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/MinimaxImageNode.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,OAAO;AACP;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,OAAO;AACP;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,eAAe;EACf,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,QAAQ;AACR;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,SAAS;AACT;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,SAAS;AACT;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;EAC1C,0BAA0B;EAC1B,yCAAyC;EACzC,uBAAuB;EACvB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,oBAAoB,GAAG,UAAU;EACjC,eAAe,QAAQ,WAAW;EAClC,iBAAiB,MAAM,WAAW;AACpC;;AAEA,eAAe;AACf;EACE,wDAAwD;EACxD,+CAA+C;EAC/C,6DAA6D;AAC/D;;AAEA,eAAe;AACf;EACE,wDAAwD;AAC1D;;AAEA,aAAa;AACb;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,6DAA6D;EAC7D,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,WAAW;AACX;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA;;EAEE,yEAAyE;AAC3E;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB","sourcesContent":["/* 海螺图片生成节点样式 */\n\n.MinimaxImageNode-container {\n  position: relative;\n  background: white;\n  border: 2px solid #ddd;\n  border-radius: 12px;\n  padding: 16px;\n  min-width: 320px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transition: box-shadow 0.3s ease;\n}\n\n.MinimaxImageNode-container:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n}\n\n.MinimaxImageNode-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  margin-bottom: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-family: monospace;\n}\n\n.MinimaxImageNode-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* 字段 */\n.MinimaxImageNode-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.MinimaxImageNode-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #333;\n}\n\n/* 按钮组 */\n.MinimaxImageNode-button-group {\n  display: flex;\n  gap: 8px;\n}\n\n.MinimaxImageNode-button {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  color: #333;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.MinimaxImageNode-button:hover:not(:disabled) {\n  border-color: #3b82f6;\n  color: #3b82f6;\n}\n\n.MinimaxImageNode-button-active {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-color: #667eea;\n}\n\n.MinimaxImageNode-button:disabled {\n  background-color: #f5f5f5;\n  color: #999;\n  cursor: not-allowed;\n}\n\n/* 下拉选择 */\n.MinimaxImageNode-select {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  background-color: white;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.MinimaxImageNode-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n}\n\n.MinimaxImageNode-select:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n/* 滑块 */\n.MinimaxImageNode-slider-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.MinimaxImageNode-slider {\n  flex: 1;\n  height: 6px;\n  border-radius: 3px;\n  background: #e5e7eb;\n  outline: none;\n  -webkit-appearance: none;\n}\n\n.MinimaxImageNode-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\n.MinimaxImageNode-slider::-webkit-slider-thumb:hover {\n  transform: scale(1.2);\n}\n\n.MinimaxImageNode-slider::-moz-range-thumb {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  cursor: pointer;\n  border: none;\n  transition: transform 0.2s ease;\n}\n\n.MinimaxImageNode-slider::-moz-range-thumb:hover {\n  transform: scale(1.2);\n}\n\n.MinimaxImageNode-slider:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.MinimaxImageNode-slider-value {\n  font-size: 12px;\n  font-weight: 600;\n  color: #667eea;\n  min-width: 50px;\n  text-align: right;\n}\n\n/* 输入框 */\n.MinimaxImageNode-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  transition: border-color 0.2s ease;\n}\n\n.MinimaxImageNode-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n}\n\n.MinimaxImageNode-input:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n/* 复选框 */\n.MinimaxImageNode-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #333;\n  cursor: pointer;\n  user-select: none;\n}\n\n.MinimaxImageNode-checkbox {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.MinimaxImageNode-checkbox:disabled {\n  cursor: not-allowed;\n}\n\n/* 画风设置区域 */\n.MinimaxImageNode-style-section {\n  padding: 12px;\n  background-color: #f9fafb;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* 高级设置 */\n.MinimaxImageNode-advanced {\n  border-top: 1px solid #e5e7eb;\n  padding-top: 12px;\n}\n\n.MinimaxImageNode-advanced-toggle {\n  width: 100%;\n  padding: 8px 12px;\n  background: transparent;\n  border: none;\n  color: #667eea;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  text-align: left;\n  transition: color 0.2s ease;\n}\n\n.MinimaxImageNode-advanced-toggle:hover:not(:disabled) {\n  color: #764ba2;\n}\n\n.MinimaxImageNode-advanced-toggle:disabled {\n  color: #999;\n  cursor: not-allowed;\n}\n\n.MinimaxImageNode-advanced-content {\n  margin-top: 12px;\n  padding: 12px;\n  background-color: #f9fafb;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* 提示信息 */\n.MinimaxImageNode-hint {\n  font-size: 11px;\n  color: #999;\n  line-height: 1.4;\n  padding: 8px;\n  background-color: #f9fafb;\n  border-radius: 6px;\n}\n\n/* 生成按钮 */\n.MinimaxImageNode-generate {\n  width: 100%;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\n}\n\n.MinimaxImageNode-generate:hover:not(.MinimaxImageNode-generate-disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.MinimaxImageNode-generate:active:not(.MinimaxImageNode-generate-disabled) {\n  transform: translateY(0);\n}\n\n.MinimaxImageNode-generate-disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* 错误提示 */\n.MinimaxImageNode-error {\n  padding: 10px 12px;\n  background-color: #fee;\n  color: #c33;\n  border-radius: 6px;\n  font-size: 12px;\n  border-left: 3px solid #c33;\n}\n\n/* Handle 样式 */\n.MinimaxImageNode-handle {\n  width: 14px;\n  height: 14px;\n  border: 2px solid #667eea;\n  background: white;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.MinimaxImageNode-handle:hover {\n  width: 18px;\n  height: 18px;\n  border-width: 3px;\n}\n\n/* 不同类型的 Handle 颜色区分 */\n.MinimaxImageNode-handle-prompt {\n  border-color: #667eea;\n  background: #667eea;\n}\n\n.MinimaxImageNode-handle-image {\n  border-color: #48bb78;\n  background: #48bb78;\n}\n\n.MinimaxImageNode-handle-output {\n  border-color: #8b5cf6;\n  background: #8b5cf6;\n}\n\n/* Handle 标签 */\n.MinimaxImageNode-handle-label {\n  position: absolute;\n  left: -70px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  letter-spacing: 0.025em;\n  z-index: 100;\n}\n\n/* 可点击的 Handle 标签 */\n.MinimaxImageNode-handle-label-clickable {\n  pointer-events: auto;  /* 改为可交互 */\n  cursor: pointer;       /* 显示手型光标 */\n  user-select: none;     /* 禁止文本选择 */\n}\n\n/* 可点击标签的悬停效果 */\n.MinimaxImageNode-handle-label-clickable:hover {\n  transform: translateY(-50%) translateX(-4px) scale(1.05);\n  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.45);\n  background: linear-gradient(135deg, #a78bfa 0%, #9333ea 100%);\n}\n\n/* 可点击标签的按下效果 */\n.MinimaxImageNode-handle-label-clickable:active {\n  transform: translateY(-50%) translateX(-2px) scale(0.98);\n}\n\n/* 添加点击提示图标 */\n.MinimaxImageNode-handle-label-clickable::after {\n  content: ' +';\n  font-weight: 700;\n  margin-left: 4px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.MinimaxImageNode-handle-label-clickable:hover::after {\n  opacity: 1;\n}\n\n/* 悬停时显示标签 */\n.MinimaxImageNode-handle:hover .MinimaxImageNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.35);\n}\n\n.MinimaxImageNode-handle:hover .MinimaxImageNode-handle-label::before {\n  content: '';\n  position: absolute;\n  right: -4px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-left: 4px solid #8b5cf6;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  filter: drop-shadow(0 1px 2px rgba(139, 92, 246, 0.2));\n}\n\n.MinimaxImageNode-handle-prompt .MinimaxImageNode-handle-label {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);\n}\n\n.MinimaxImageNode-handle-prompt:hover .MinimaxImageNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.MinimaxImageNode-handle-prompt:hover .MinimaxImageNode-handle-label::before {\n  border-left-color: #667eea;\n  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));\n}\n\n.MinimaxImageNode-handle-image .MinimaxImageNode-handle-label {\n  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);\n  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);\n}\n\n.MinimaxImageNode-handle-image:hover .MinimaxImageNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n.MinimaxImageNode-handle-image:hover .MinimaxImageNode-handle-label::before {\n  border-left-color: #48bb78;\n  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));\n}\n\n/* 节点被选中时，一直显示标签 */\n.react-flow__node.selected .MinimaxImageNode-handle .MinimaxImageNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.35);\n}\n\n.react-flow__node.selected .MinimaxImageNode-handle-prompt .MinimaxImageNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.react-flow__node.selected .MinimaxImageNode-handle-image .MinimaxImageNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n/* 标签出现动画 */\n@keyframes MinimaxImageNode-labelFadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-50%) translateX(-10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(-50%) translateX(-2px);\n  }\n}\n\n.MinimaxImageNode-handle:hover .MinimaxImageNode-handle-label,\n.react-flow__node.selected .MinimaxImageNode-handle .MinimaxImageNode-handle-label {\n  animation: MinimaxImageNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* 连接状态显示 */\n.MinimaxImageNode-status {\n  margin-bottom: 12px;\n  padding: 12px;\n  background: #f9fafb;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.MinimaxImageNode-status-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 0;\n}\n\n.MinimaxImageNode-status-item:not(:last-child) {\n  border-bottom: 1px dashed #e5e7eb;\n  margin-bottom: 6px;\n  padding-bottom: 8px;\n}\n\n.MinimaxImageNode-status-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.MinimaxImageNode-status-value {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.MinimaxImageNode-status-connected {\n  color: #10b981;\n  background: #d1fae5;\n  border: 1px solid #10b981;\n}\n\n.MinimaxImageNode-status-disconnected {\n  color: #ef4444;\n  background: #fee2e2;\n  border: 1px solid #ef4444;\n}\n\n/* 复制按钮 */\n.MinimaxImageNode-duplicate-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  color: #666;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  opacity: 0;\n  pointer-events: none;\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.MinimaxImageNode-container:hover .MinimaxImageNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.MinimaxImageNode-duplicate-button:hover {\n  background: #f0f0f0;\n  border-color: #3b82f6;\n  color: #3b82f6;\n  transform: scale(1.05);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
